import { parseAndProfileCsv, prepareMappingDraft } from '../../../lib/disclosure_core.js';
import { getDisclosure } from './api.js';

export const disclosureDraft = $state({
  sourceId: null, connector: null, catalog: null, mapping: null, aggregateMapping: null, otherMappings: null, aggregations: null,
  fileName: null, rows: [], headers: [], profiles: [], notes: {}, dirty: false, loaded: false,
  // The row being inspected, 1-based, held here rather than in a component so it
  // survives moving between steps — you keep your place in the file.
  rowIndex: 1,
});

export function loadDraft(data) {
  disclosureDraft.sourceId = data.sourceId;
  disclosureDraft.connector = data.connector;
  disclosureDraft.catalog = data.catalog;
  disclosureDraft.mapping = prepareMappingDraft(data.mapping);
  disclosureDraft.aggregateMapping = prepareMappingDraft(data.aggregateMapping ?? data.mapping);
  disclosureDraft.otherMappings = structuredClone(data.otherMappings ?? { columns: [], records: {} });
  disclosureDraft.aggregations = structuredClone(data.aggregations);
  disclosureDraft.loaded = true;
  disclosureDraft.dirty = false;
}

export async function ensureDraft(sourceId) {
  if (!sourceId || (disclosureDraft.loaded && disclosureDraft.sourceId === sourceId)) return;
  if (disclosureDraft.dirty && !window.confirm(`Discard the unsaved changes for ${disclosureDraft.sourceId}?`)) return;
  loadDraft(await getDisclosure(sourceId));
}

export function loadCsv(fileName, text) {
  const parsed = parseAndProfileCsv(text);
  disclosureDraft.fileName = fileName;
  disclosureDraft.rows = parsed.rows;
  disclosureDraft.headers = parsed.headers;
  disclosureDraft.profiles = parsed.profiles;
  disclosureDraft.rowIndex = 1;
  disclosureDraft.dirty = true;
  return parsed;
}

export function markDirty() { disclosureDraft.dirty = true; }
export function clearRawSample() {
  disclosureDraft.fileName = null; disclosureDraft.rows = []; disclosureDraft.headers = []; disclosureDraft.profiles = [];
  disclosureDraft.rowIndex = 1;
}

// The draft lives only in this tab: no autosave, no server-side draft (plan
// decision 2). Closing or reloading the tab therefore throws the work away, so
// the browser's own warning is the only thing standing between a dirty draft
// and a lost afternoon. In-app navigation needs no guard: this store is
// module-level, so moving between screens keeps the draft intact.
window.addEventListener('beforeunload', (event) => {
  if (!disclosureDraft.dirty) return;
  event.preventDefault();
  event.returnValue = '';
});
